export default __webpack_public_path__ + "static/media/fish_grayscale.71c0eb49.svg";